import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import { FaEye, FaEyeSlash } from "react-icons/fa";
 
const Resetpassword = () => {
  const WebDetails = useSelector(state => state.logo);
  const [ResetError, setResetError] = useState(null);
  const history = useNavigate();
  const prm = {
    // email: methodModel.getPrams('email'),
    id: methodModel.getPrams("id"),
    code: methodModel.getPrams("code"),
  };
  const user = useSelector((state) => state.user);
  useEffect(() => {
    // if (localStorage.getItem("token")) {
    //   history("/dashboard");
    // }
    let message = methodModel.getPrams("message");
    // if(message) toast.success(message)
  }, []);

  const formValidation = [
    {
      key: "confirmPassword",
      minLength: 8,
      confirmMatch: ["confirmPassword", "newPassword"],
    },
    { key: "newPassword", minLength: 8 },
  ];

  const [form, setForm] = useState({
    confirmPassword: "",
    newPassword: "",
    code: "",
    id: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [eyes, setEyes] = useState({ password: false, confirmPassword: false });

  const getError = (key) => {
    return methodModel.getError(key, form, formValidation);
  };

  const [Ip, setIp] = useState('NULL')
  useEffect(() => {

    setForm({ ...form, ...prm });
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        let ip = data.ip
        localStorage.setItem('IP', ip)
        setIp(ip)
      })
      .catch(error => { });
  }, []);


  const hendleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setResetError(null)
    if (form?.newPassword != form?.confirmPassword) {
      return
    }
    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid) return;
    let ValidateResponse = methodModel.validatePassword(form.newPassword)
    if (!ValidateResponse?.success) {
      setResetError(ValidateResponse?.message);
      return
    }
    loader(true);
    let payload = {
      password: form.newPassword,
      verificationCode: form.code,
      id: form.id,
      ip: Ip
    };

    let url = 'user/reset/password'

    if (!prm.id) {
      url = 'user/set/password'
      payload = {
        id: user?.id || user?._id,
        newPassword: form.newPassword,
      }
    }

    ApiClient.put(url, payload, '', true, setResetError).then((res) => {
      if (res.success) {
          history("/login");
      }
      loader(false);
    });
  };

  return (
    <>
     <div className="">
      <div className="h-screen overflow-auto flex items-start p-5"  style={{ backgroundImage: "url('/assets/img/auth-bg.webp')" }}>
          <div className="max-w-[550px] w-full h-fit bg-white rounded-[40px] sm:p-[4rem] p-[1.5rem] m-auto">
  <div className="w-full bg-white">
                <img
                  src="/assets/img/logo.png"
                  className="w-[110px] object-contain mx-auto mb-4"
                  alt="logo"
                />
              <div className="">
                <form onSubmit={hendleSubmit}>
                  <div className="mb-5">
                      <h3 class="text-[22px] font-[600] text-center leding-[28px]">  Reset Password</h3>
                      <p class="text-[14px] font-[300] max-w-[328px] text-center mx-auto"> Please create a new password that you don’t use on any other
                    site.</p>
                    </div>
                  <h4 className="text-typo mb-6 text-2xl font-medium">
                  
                  </h4>
                   <div className="space-y-4">
                  <div className="">
                      <p class="text-sm pb-1 font-[400] text-[#737373]">New Password</p>
                    <div className="relative">
                      <input
                        type={eyes.password ? "text" : "password"}
                        className="border !outline-none h-11 rounded-[12px] w-full text-sm pl-3 pr-9"
                        value={form.newPassword}
                        min="12"
                        onChange={(e) =>
                          setForm({ ...form, newPassword: e.target.value })
                        }
                        placeholder="Create new password"
                        required
                      />


                      {eyes.password ? (
                        <FaEye
                          className="top-[15px] right-3 absolute text-gray-600 cursor-pointer hover:opacity-80"
                          onClick={() =>
                            setEyes({ ...eyes, password: !eyes.password })
                          }
                        />
                      ) : (
                        <FaEyeSlash
                          className="top-[15px] right-3 absolute text-gray-600 cursor-pointer hover:opacity-80"
                          onClick={() =>
                            setEyes({ ...eyes, password: !eyes.password })
                          }
                        />
                      )}


                    </div>
                    {submitted && getError("newPassword").invalid ? (
                      <div className="text-red-600 text-xs mt-1">
                        Min Length must be 8 characters long
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="">
  <p class="text-sm pb-1 font-[400] text-[#737373]">Confirm Password</p>
                    <div className="relative">
                      <input
                        type={eyes.confirmPassword ? "text" : "password"}
                        className="border !outline-none h-11 rounded-[12px] w-full text-sm pl-3 pr-9"
                        value={form.confirmPassword}
                        maxLength={50}
                        onChange={(e) =>
                          setForm({ ...form, confirmPassword: e.target.value })
                        }
                        placeholder="Confirm new password"
                        required
                      />
                      {submitted && form?.newPassword != form?.confirmPassword ? (
                        <div className="text-red-600 text-xs mt-1">
                          Confirm Password is not matched with New Password
                        </div>
                      ) : (
                        <></>
                      )}
                      <i
                        className={
                          eyes.confirmPassword ? "fa fa-eye" : "fa fa-eye-slash"
                        }
                        onClick={() =>
                          setEyes({
                            ...eyes,
                            confirmPassword: !eyes.confirmPassword,
                          })
                        }></i>

                           {eyes.confirmPassword ? (
                      <FaEye
                        className="top-[15px] right-3 absolute text-gray-600 cursor-pointer hover:opacity-80"
                        onClick={() =>
                          setEyes({ ...eyes, confirmPassword: !eyes.confirmPassword })
                        }
                      />
                    ) : (
                      <FaEyeSlash
                        className="top-[15px] right-3 absolute text-gray-600 cursor-pointer hover:opacity-80"
                        onClick={() =>
                          setEyes({ ...eyes, confirmPassword: !eyes.confirmPassword })
                        }
                      />
                    )}
                    </div>



                 
                  </div>
                  </div>

                  {ResetError ? <div className="text-red-600 text-xs mt-1 mb-1 text-center">
                    {ResetError}
                  </div> : null}
                  <div className="mt-7">
                  <button
                    type="submit"
                    className="!px-4 w-full text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 !bg-[#115B9D] rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed">
                    Save
                  </button>
                  </div>
                  {prm.id ? <>
                    <p className="text-sm text-[#202020] text-center">
                      {" "}
                      Just Remember?
                      <Link className="text-[#115B9D]   font-medium" to="/login">
                        {" "}
                        Sign In
                      </Link>
                    </p>
                  </> : <></>}

                </form>
              </div>
        </div>
        </div>
        </div>
      </div>

      <ToastContainer position="top-right" />
    </>
  );
};

export default Resetpassword;
